var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"4"}},[_c('button',{staticClass:"btn-submit",on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("Bay Bek")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }